<template lang="">
  <main>
    <div class="title">
      <h1>Confira nossos Objetos de Aprendizagem</h1>
    </div>
    <!-- <div class="select">
      <select name="" id="">
        <option value="1"><p>Mais recentes</p></option>
        <option value="2"><p>Mais antigos</p></option>
      </select>
    </div> -->
    <MyCard :oasAtributes="oasAtributes" />
    <a class="btn-vermais" type="button" href="/oas">
      <p>Ver mais</p>
    </a>
  </main>
</template>
<script>
import { defineComponent } from "vue";
import MyCard from "../MyCard.vue";

export default defineComponent({
  name: "OAs",
  components: {
    MyCard,
  },
});
</script>

<style scoped lang="css">
main {
  display: flex;
  flex-direction: column;
  margin: 50px;
  align-items: center;
}

h1 {
  color: var(--terracota);
}

.title {
  margin-bottom: 30px;
  text-align: center;
}

.select {
  display: flex;
  align-self: stretch;
  height: 50px;
  width: 10%;
}
.select select {
  font-size: 16px !important;
  height: 100%;
  width: 100%;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid var(--silver-medal);
  color: var(--orange);
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.select option {
  background-color: var(--orange);
}

.btn-vermais {
  border-radius: 4px;
  background: var(--orange, #da372e);
  color: var(--white);
  border: none;
  cursor: pointer;
  display: flex;
  width: 10%;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  align-content: center;
}
</style>
